module.exports = __webpack_public_path__ + "static/media/galerija_2019 (45).c94051ec.jpg";